import { useState } from 'react';
import { useAppStatus, Severity } from 'src/context/AppStatusContext';
import { BannerStrip, BannerVariant } from 'src/components/common/banner/BannerStrip';

const SEVERITY_ORDER: Record<Severity, number> = { Critical: 0, Warning: 1, Information: 2 };
const SEVERITY_VARIANT: Record<Severity, BannerVariant> = { Critical: 'critical', Warning: 'warning', Information: 'information' };

const StatusMessageBanner = () => {
    const { activeStatusMessages } = useAppStatus();
    const [dismissedIds, setDismissedIds] = useState<Set<number>>(new Set());

    const visible = activeStatusMessages
        .filter((m) => !dismissedIds.has(m.id))
        .sort((a, b) => SEVERITY_ORDER[a.severity as Severity] - SEVERITY_ORDER[b.severity as Severity]);

    if (visible.length === 0) return null;

    const dismiss = (id: number) => setDismissedIds((prev) => new Set(prev).add(id));

    return (
        <>
            {visible.map((msg) => (
                <BannerStrip
                    key={msg.id}
                    variant={SEVERITY_VARIANT[(msg.severity as Severity) ?? 'Information']}
                    message={msg.message}
                    onDismiss={() => dismiss(msg.id)}
                    dismissAriaLabel="Dismiss status message"
                />
            ))}
        </>
    );
};

export default StatusMessageBanner;
